module.exports = __webpack_public_path__ + "static/media/close-icon-black.3a6504bc.svg";